(function (jQuery, undefined) {

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.custom === "undefined") {
        jQuery.extend(sm.portal.vm, { custom: {}});
    }
    if (typeof sm.portal.vm.custom.document_checklist === "undefined") {
        jQuery.extend(sm.portal.vm.custom, { document_checklist: {}});
    }

    function LocalizeKeys(){
        var keys = {
            RequiredDocumentsText : sm.portal.utility.getResourceValue('AdmissionsDocument'),
        }
        return keys;
      }
    function CheckDocumentStatus(data) {
        if (data.StatusBusinessMeaningName == 'ApplicationProcessStepStatus.Complete' || data.StatusBusinessMeaningName == 'ApplicationProcessStepStatus.Waived') {
            return true;
        }
        else
            return false;
    }

    jQuery.extend(true, sm.portal.vm.custom.document_checklist, {
        CheckDocumentStatus: CheckDocumentStatus,
        LocalizeKeys: LocalizeKeys,
    });

})(jQuery);